// constants/testIds/site.js — le site desktop (≥ 768 px, hors éditions
// physiques), construit en vagues depuis le 07/09/2026
// (memory/strategie/SITE_WEB_DESKTOP.md). Le téléphone garde MOBILE, le
// Livre du lobby garde BOOK : ce registre est celui de la troisième porte.
export const SITE = {
    app: 'site-app',
    // En-tête
    header: 'site-header',
    brand: 'site-brand',
    // Le logo officiel peint depuis sa matte (audit 10/09) — nu, aucun
    // identifiant suffixé ne commence par `site-brand-`.
    brandLogo: 'site-brand-logo',
    nav: 'site-nav',
    navLink: 'site-nav-link',          // suffixe -${name}
    langToggle: 'site-lang-toggle',
    langMenu: 'site-lang-menu',
    langOption: 'site-lang-option',    // suffixe -${code}
    // Pied
    footer: 'site-footer',
    footerLink: 'site-footer-link',    // suffixe -${name}
    footerStay: 'site-footer-stay',
    // Audit 10/09 (parcours n°1) : le téléphone du canon, composable d'un tap.
    footerTel: 'site-footer-tel',
    // Accueil
    // ⚑ L'OUVERTURE a remplacé le héros en deux colonnes le 13/09/2026 : plein
    // cadre, et le film de la maison dessous. `hero` reste déclaré — d'autres
    // surfaces le portent (`ficheHero`), et un identifiant qu'on retire casse
    // les marches de contrôle sans rien gagner.
    ouverture: 'site-ouverture',
    ouvertureFilm: 'site-ouverture-film',
    hero: 'site-hero',
    heroCta: 'site-hero-cta',
    merveilles: 'site-merveilles',
    merveillesAll: 'site-merveilles-all',
    card: 'site-card',                 // suffixe -${id}
    // ⚠ Sous `site-carte-…`, pas `site-card-…` : `site-card` est suffixé par
    // id, et un préfixe `site-card-` les attraperait (la faute du 08/09).
    cardProse: 'site-carte-prose',     // la prose de la période, sous le nom
    cardWalk: 'site-carte-marche',     // la distance à pied, quand la case n'a pas de photo
    // Le sceau « Film » sur une carte dont la fiche porte un clip (13/09/2026).
    // Sous `site-carte-…` comme ses voisins : `site-card` est suffixé par id.
    cardFilm: 'site-carte-film',       // suffixe -${id}
    // La bande panoramique de la ville (13/09/2026) — la respiration pleine
    // largeur entre la vitrine et la frise.
    ville: 'site-ville',
    frise: 'site-frise',
    friseCouche: 'site-frise-couche',  // suffixe -${key}
    // La ligne de date d'une couche sur la bande de l'accueil (audit 10/09) —
    // `site-frise-date-`, jamais `site-frise-couche-date-` (préfixe suffixé).
    friseDate: 'site-frise-date',      // suffixe -${key}
    // « carte-du-jour » et non « card-of-day » : ce dernier prolongeait
    // `site-card`, suffixé par id — un sélecteur `^="site-card-"` l'aurait
    // compté parmi les cartes. Collision latente trouvée par la garde du 08/09.
    cardOfDay: 'site-carte-du-jour',
    identity: 'site-identity',
    identityStay: 'site-identity-stay',
    // Audit 10/09 (parcours n°2) : la plaque mène au Manoir, sans dépendre
    // d'une adresse de réservation.
    identityManoir: 'site-identity-manoir',
    identitySuites: 'site-identity-suites',
    navy: 'site-navy',
    qr: 'site-qr',
    // Catalogue
    catalogue: 'site-catalogue',
    catalogueFilter: 'site-catalogue-filter', // suffixe -${family}
    catalogueCount: 'site-catalogue-count',
    // Le dévoilement progressif (08/09) — le bouton PORTE le contrat, la
    // sentinelle ne fait que l'actionner d'avance. Voir useProgressiveList.
    catalogueMore: 'site-catalogue-more',
    catalogueSentinelle: 'site-catalogue-sentinelle',
    // Les mentions légales (vague 3k) — ce que la maison déclare d'elle-même,
    // et ce qu'elle avoue ne pas encore savoir.
    mentions: 'site-mentions',
    mentionsEditeur: 'site-mentions-editeur',
    mentionsDirecteur: 'site-mentions-directeur',
    mentionsHebergeur: 'site-mentions-hebergeur',
    mentionsManquantes: 'site-mentions-manquantes',
    mentionsLigne: 'site-mentions-ligne',    // suffixe -${cle}
    mentionsManque: 'site-mentions-manque',  // suffixe -${cle}
    // Fiche
    fiche: 'site-fiche',
    ficheHero: 'site-fiche-hero',
    ficheCredit: 'site-fiche-credit',
    ficheTitle: 'site-fiche-title',
    ficheListen: 'site-fiche-listen',
    ficheStop: 'site-fiche-stop',
    ficheVoiceLost: 'site-fiche-voice-lost',
    ficheNarrative: 'site-fiche-narrative',
    ficheRegister: 'site-fiche-register',
    ficheRegisterRow: 'site-fiche-register-row',
    ficheRegisterMore: 'site-fiche-register-more',
    ficheMap: 'site-fiche-map',
    ficheDistance: 'site-fiche-distance',
    ficheItinerary: 'site-fiche-itinerary',
    ficheSources: 'site-fiche-sources',
    ficheSource: 'site-fiche-source',
    ficheGallery: 'site-fiche-gallery',
    ficheNext: 'site-fiche-next',      // suffixe -${id}
    // Audit 10/09 (parcours n°5, n°6, n°7) : les rebonds tournent et disent
    // leur motif ; « à quelques pas » ; l'étape de balade.
    ficheRebonds: 'site-fiche-rebonds',
    voisins: 'site-a-quelques-pas',
    voisin: 'site-voisin',             // suffixe -${id}
    etapesBalade: 'site-etapes-balade',
    etapeBalade: 'site-etape-balade',  // suffixe -${tourId}
    ficheCrumbs: 'site-fiche-crumbs',
    ficheCrumbHome: 'site-fiche-crumb-home',
    ficheCrumbMonuments: 'site-fiche-crumb-monuments',
    ficheCreditLink: 'site-fiche-credit-link',
    ficheFallbackNote: 'site-fiche-fallback-note',
    // Le corps de la fiche (récit, repères, sources) vient du DÉTAIL depuis le
    // 09/09/2026 : la carte du catalogue ne le porte plus (site_cartes.py).
    // Il a donc deux états de plus, et ils sont visibles.
    ficheBodyPending: 'site-fiche-body-pending',
    ficheBodyFailed: 'site-fiche-body-failed',
    ficheBodyRetry: 'site-fiche-body-retry',
    // Fiche — les trois autres familles (vague 2b)
    ficheKind: 'site-fiche-kind',            // kind / rôle sous le titre
    ficheBadge: 'site-fiche-badge',          // « attribution débattue »
    ficheOuVoir: 'site-fiche-ou-voir',       // le cartel d'un trésor
    ficheOuVoirStatus: 'site-fiche-ou-voir-status',
    ficheOuVoirLieu: 'site-fiche-ou-voir-lieu',
    ficheOuVoirNote: 'site-fiche-ou-voir-note',
    ficheConfidence: 'site-fiche-confidence', // la nuance d'une fête
    ficheHost: 'site-fiche-host',            // le monument lié (« Où l'admirer » …)
    ficheHostLink: 'site-fiche-host-link',
    ficheImageNote: 'site-fiche-image-note',
    ficheReperesFrench: 'site-fiche-reperes-french',
    ficheVideo: 'site-fiche-video',
    ficheAr: 'site-fiche-ar',
    // Audit du 10/09/2026 (vérité & sept langues). Aucun ne prolonge un
    // identifiant SUFFIXÉ : `site-vignette-credit` et non `site-card-credit`,
    // parce que `site-card` est suffixé par id — la garde des collisions.
    vignetteCredit: 'site-vignette-credit',      // le crédit sur la vignette
    ficheKindFrench: 'site-fiche-kind-french',   // « en français pour l'instant » sous le rôle
    ficheSansLieu: 'site-fiche-sans-lieu',       // l'orphelin de carte le DIT
    fichePointEmprunte: 'site-fiche-point-emprunte', // « l'épingle est celle de son voisin, … » (ou « point approximatif » sans voisin chargé)
    figuresRolesFrench: 'site-figures-roles-french',
    manoirFrenchNote: 'site-manoir-french-note',
    suitePaletteFrench: 'site-suite-palette-french',
    // Audit 10/09 — la prose de la période, sous le titre (l'œil-de-bœuf ne
    // garde que la clause datée) ; le bouton Partager, désormais libellé.
    fichePeriod: 'site-fiche-period',
    ficheShare: 'site-fiche-share',
    // Catalogues des trois familles
    tresors: 'site-tresors',
    tresorsSection: 'site-tresors-section',  // suffixe -${categorie}
    figures: 'site-figures',
    figuresCreusent: 'site-figures-creusent',
    fetes: 'site-fetes',
    // La frise des époques (vague 3a)
    friseVoies: 'site-frise-voies',
    friseRow: 'site-frise-row',             // suffixe -${key}
    friseLane: 'site-frise-lane',           // suffixe -${key}-${famille}
    // Idem : ces deux-là prolongeaient `site-frise-couche`, suffixé par clef.
    friseCouchePage: 'site-couche-page',
    friseCoucheCard: 'site-couche-card',    // suffixe -${famille}-${id}
    friseAussiDans: 'site-frise-aussi-dans', // suffixe -${key}
    friseRegister: 'site-frise-register',
    friseRegisterRow: 'site-frise-register-row', // suffixe -${famille}-${id}
    friseVitrine: 'site-frise-vitrine',
    // La page de Médard (vague 3g) — dernière porte du site
    medard: 'site-medard',
    medardLois: 'site-medard-lois',
    medardLoi: 'site-medard-loi',                // suffixe -${n}
    medardJamais: 'site-medard-jamais',
    medardJamaisLigne: 'site-medard-jamais-ligne', // suffixe -${cle}
    medardTelephone: 'site-medard-telephone',
    medardDevise: 'site-medard-devise',
    // Audit 10/09 (parcours n°8) : la page se termine par des portes.
    medardPortes: 'site-medard-portes',
    medardPorte: 'site-medard-porte',            // suffixe -${cle}
    // Le Manoir et ses suites (vague 3f)
    manoir: 'site-manoir',
    manoirAdresse: 'site-manoir-adresse',
    manoirStay: 'site-manoir-stay',
    // Audit 10/09 (parcours n°1) : le téléphone du canon, sur la page de la maison.
    manoirTel: 'site-manoir-tel',
    manoirSuite: 'site-manoir-suite',            // suffixe -${id}
    // ⚑ « porte » et « source », PAS « suite-lien » / « suite-monument » : un
    // sélecteur par préfixe sur `site-manoir-suite-` les attraperait tous les
    // trois. Troisième fois que cette collision mord (3c, puis ici) — d'où la
    // garde `testIdsSansCollision` qui l'interdit désormais.
    manoirPorte: 'site-manoir-porte',            // suffixe -${id}
    manoirSource: 'site-manoir-source',          // suffixe -${id}
    // La galerie des films (14/09/2026). ⚠ `site-film-*` et NON un préfixe
    // de `site-films-*` : un sélecteur `^="site-films"` attraperait la page
    // ET les cartes, exactement la collision des vagues 3c et 3f.
    filmsPage: 'site-films-page',
    filmsGrid: 'site-films-grid',
    filmCard: 'site-film-card',            // suffixe -${id}
    filmPlay: 'site-film-play',            // suffixe -${id}
    filmVideo: 'site-film-video',          // suffixe -${id}
    filmFiche: 'site-film-fiche',          // suffixe -${id}
    suitePage: 'site-suite-page',
    suitePhoto: 'site-suite-photo',
    // ⚠ `site-suite-detail`, PAS `site-suite-photo-detail` : la garde de
    // collision ne vise que les identifiants suffixés, elle ne rougirait donc
    // pas — mais un sélecteur `^="site-suite-photo"` écrit un jour de hâte
    // attraperait les deux figures, et c'est très exactement la faute des
    // vagues 3c et 3f.
    suiteDetailPhoto: 'site-suite-detail',
    suiteAnecdotes: 'site-suite-anecdotes',
    suiteAnecdote: 'site-suite-anecdote',        // suffixe -${i}
    suiteFallbackNote: 'site-suite-fallback-note',
    suiteMonument: 'site-suite-monument',
    suiteExperiences: 'site-suite-experiences',
    suiteExperience: 'site-suite-experience',    // suffixe -${id}
    // La Bibliothèque de Médard (vague 3e)
    bibliotheque: 'site-bibliotheque',
    biblioFeatured: 'site-biblio-featured',
    biblioCollection: 'site-biblio-collection',  // suffixe -${id}
    biblioCycle: 'site-biblio-cycle',            // suffixe -${id}
    biblioTitre: 'site-biblio-titre',            // suffixe -${id}
    biblioLire: 'site-biblio-lire',              // suffixe -${id}
    biblioStatut: 'site-biblio-statut',          // suffixe -${id}
    biblioPhase2: 'site-biblio-phase2',
    contePage: 'site-conte-page',
    conteCover: 'site-conte-cover',
    contePlanches: 'site-conte-planches',
    contePlanche: 'site-conte-planche',          // suffixe -${n}
    conteAr: 'site-conte-ar',                    // suffixe -${n}
    conteLeVrai: 'site-conte-le-vrai',
    conteLeVraiBloc: 'site-conte-le-vrai-bloc',  // suffixe -${i}
    // Le carrefour du canon (vague 3d)
    autun: 'site-autun',
    autunPorte: 'site-autun-porte',       // suffixe -${page}
    // Refonte du 11/09 : la porte NOMME trois entrées au lieu de compter des
    // fiches. Identifiant propre (jamais un suffixe de `site-autun-porte`,
    // qui est déjà suffixé par page — la garde des collisions).
    autunPorteNoms: 'site-autun-noms',    // suffixe -${page}
    // Les balades de Médard (vague 3c)
    balades: 'site-balades',
    baladeCard: 'site-balade-card',          // suffixe -${id}
    baladeTheme: 'site-balade-theme',        // suffixe -${themeId}
    baladePage: 'site-balade-page',
    baladeStop: 'site-balade-stop',          // suffixe -${index}
    // ⚑ « site-balade-door », pas « …-stop-link » : un sélecteur par préfixe
    // (`[data-testid^="site-balade-stop-"]`) attrapait les DEUX. Un préfixe
    // d'identifiant ne doit jamais en contenir un autre.
    baladeStopDoor: 'site-balade-door',     // suffixe -${monument_id}
    // L'encart pratique (10/09/2026) : « comment la faire », et l'aveu quand
    // cette note n'existe qu'en français au canon.
    // ⚠ `site-balade-best-mode` et `site-balade-french-note` ne prolongent
    // aucun identifiant suffixé de cette liste — la garde des collisions le
    // vérifie, et c'est la QUATRIÈME fois que ce piège se présente ici.
    baladeBestMode: 'site-balade-best-mode',
    baladeFrenchNote: 'site-balade-french-note',
    baladeMeasure: 'site-balade-measure',
    baladeNote: 'site-balade-note',          // suffixe -${rangeRover|picnic}
    // Le téléphone devant une page du seul grand écran (audit 10/09/2026,
    // mobile n°2) : l'adresse est gardée, la note le dit, la porte mène à l'app.
    wideOnly: 'site-grand-ecran',
    wideOnlyHome: 'site-grand-ecran-accueil',
    // Les mentions légales rendues SEULES, à toute largeur (audit 10/09,
    // mobile n°1) : la coquille sans bandeau du site, avec sa porte de sortie.
    mentionsSeules: 'site-mentions-seules',
    mentionsSeulesHome: 'site-mentions-seules-accueil',
    // La carte d'Autun (audit 10/09 bis, parcours n°6) — le canevas du
    // téléphone, la liste qui centre l'épingle, les points empruntés déclarés.
    // ⚠ `site-carte-…` ne prolonge aucun identifiant SUFFIXÉ (`site-card` est
    // suffixé par id, et « carte » n'en est pas un préfixe : la garde le tient).
    carte: 'site-carte-autun',
    carteCanevas: 'site-carte-canevas',
    carteCompte: 'site-carte-compte',
    carteListe: 'site-carte-liste',
    carteLieu: 'site-carte-lieu',          // suffixe -${id}
    carteVoir: 'site-carte-voir',          // suffixe -${id}
    carteSansEpingle: 'site-carte-sans-epingle',
    carteEmprunte: 'site-carte-emprunte',  // suffixe -${id}
    voisinsCarte: 'site-a-quelques-pas-carte',
    // La cité antique en 3D (10/10/2026) — la page, la boîte qui RÉSERVE la
    // hauteur du visualiseur (il arrive dans son propre chunk), la légende
    // ①②③ de la page, ses rebonds, et les portes qui y mènent depuis la
    // carte, la couche Augustodunum de la frise et deux fiches. Le
    // visualiseur garde ses propres identifiants (CITE, testIds/cite.js).
    // ⚠ `site-cite-…` ne prolonge aucun identifiant suffixé (`site-carte-…`,
    // `site-card`) : la garde des collisions le tient.
    citePage: 'site-cite-page',
    citeScene: 'site-cite-scene',
    // Le chunk du visualiseur ne s'est pas téléchargé : on recharge la page
    // (React.lazy garde la promesse rejetée, réessayer sans recharger ne
    // retenterait rien).
    citeRecharger: 'site-cite-recharger',
    citeDegres: 'site-cite-degres',
    citeAussi: 'site-cite-aussi',
    citeAussiLien: 'site-cite-lien',       // suffixe -${cle}
    citePorte: 'site-cite-porte',          // suffixe -${ou}
    // États
    loading: 'site-loading',
    failed: 'site-failed',
    retry: 'site-retry',
    notFound: 'site-not-found',
    notFoundHome: 'site-not-found-home',
    // La page d'attente — le Manoir n'a pas encore ouvert (15/09/2026).
    bientot: 'site-bientot',
    bientotErreur: 'site-bientot-erreur',
    bientotCourriel: 'site-bientot-courriel',
};
